export enum HintId {
	ShopPriceList = 0,
}
